// extracted by mini-css-extract-plugin
module.exports = {"postCard":"post-loading_postCard__cIg8X","postImg":"post-loading_postImg__Vgwge"};